import ESTIMATE_CONSTANT from "../../../../constant/estimateConstant"
import getDisplayCondition from "../../../../service/getDisplayCondition"
import getNumberOfLayers from "../../../../service/getNumberOfLayers"
import type EstimateValues from "../../../../types/params"
import getNumberOfMinPattern from "../../getNumberOfMinPattern"

const replaceFpcBoardThickness = (values: EstimateValues) => {
  const isDisplayed = getDisplayCondition(values)
  const numberOfMinPattern = getNumberOfMinPattern(values)
  const numberOfLayers = getNumberOfLayers(values)

  if (isDisplayed.fpcBoardThickness) {
    switch (values.fpcBoardThickness) {
      case ESTIMATE_CONSTANT.ベース材厚["12.5μm(0.1mm未満)"].value:
      case ESTIMATE_CONSTANT.ベース材厚["12.5μm(0.1mm以上__片面)"].value:
      case ESTIMATE_CONSTANT.ベース材厚["12.5μm(0.1mm以上__2層)"].value:
      case ESTIMATE_CONSTANT.ベース材厚["12.5μm(3層)"].value:
      case ESTIMATE_CONSTANT.ベース材厚["12.5μm(4層)"].value:
        if (numberOfLayers === 3) return ESTIMATE_CONSTANT.ベース材厚["12.5μm(3層)"].value
        if (numberOfLayers === 4) return ESTIMATE_CONSTANT.ベース材厚["12.5μm(4層)"].value
        if (numberOfMinPattern < 0.1) return ESTIMATE_CONSTANT.ベース材厚["12.5μm(0.1mm未満)"].value
        if (numberOfMinPattern >= 0.1 && numberOfLayers === 1)
          return ESTIMATE_CONSTANT.ベース材厚["12.5μm(0.1mm以上__片面)"].value
        if (numberOfMinPattern >= 0.1 && numberOfLayers === 2)
          return ESTIMATE_CONSTANT.ベース材厚["12.5μm(0.1mm以上__2層)"].value
        break

      case ESTIMATE_CONSTANT.ベース材厚["25μm(0.1mm未満)"].value:
      case ESTIMATE_CONSTANT.ベース材厚["25μm(0.1mm以上__片面)"].value:
      case ESTIMATE_CONSTANT.ベース材厚["25μm(0.1mm以上__2層)"].value:
        if (numberOfMinPattern < 0.1) return ESTIMATE_CONSTANT.ベース材厚["25μm(0.1mm未満)"].value
        if (numberOfMinPattern >= 0.1 && numberOfLayers === 1)
          return ESTIMATE_CONSTANT.ベース材厚["25μm(0.1mm以上__片面)"].value
        if (numberOfMinPattern >= 0.1 && numberOfLayers === 2)
          return ESTIMATE_CONSTANT.ベース材厚["25μm(0.1mm以上__2層)"].value
        break
    }
  }

  return values.fpcBoardThickness
}

export default replaceFpcBoardThickness
